/**
 * Runtime detection — are we in a browser PWA or wrapped by Capacitor?
 *
 * In v1 we only ship the PWA path. The Capacitor branches are documented
 * but not implemented — they land in M5 when we generate the Android target.
 */
export type Runtime = 'browser' | 'capacitor';

export function detectRuntime(): Runtime {
  // Capacitor injects `window.Capacitor` into the WebView. Importing from
  // `@capacitor/core` would force the plugin into every browser bundle, so
  // we feature-detect on the global instead.
  const w = window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } };
  return w.Capacitor?.isNativePlatform?.() ? 'capacitor' : 'browser';
}

export function isIos(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as unknown as { MSStream?: unknown }).MSStream;
}
